<app-oauth></app-oauth>
<app-page-loader></app-page-loader>

<div class="kt-grid kt-grid--hor kt-grid--root" *ngIf="appLoad">

  <div *blockUI="'app-page'" class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">

    <stg-ngx-left-nav *ngIf="isNotUnauthorized" [menuList]="menuItems" [minimizeOnLoad]="true"
      showSubMenuOn="hover"></stg-ngx-left-nav>

    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">

      <stg-ngx-header *ngIf="isNotUnauthorized" [headerLogo]="logo" [profileImageUrl]="profileImageUrl"
        [profileMenuItems]="profileItems">
      </stg-ngx-header>

      <app-page-header #pageHeader>
        <app-hierarchy-selector *ngIf="showHierarchySelector" [disabled]="hierarchySelectorDisabled"
          [showHierarchyLabel]="true">
        </app-hierarchy-selector>
        <hospital-selector *ngIf="showHospitalSelector" [disabled]="hospitalSelectorDisabled"></hospital-selector>
      </app-page-header>

      <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
        <div class="kt-container kt-grid__item kt-grid__item--fluid kt-container--fluid">
          <block-ui>
            <div *ngIf="showRouter">
              <router-outlet></router-outlet>
            </div>
          </block-ui>
        </div>
      </div>

      <stg-ngx-footer *ngIf="isNotUnauthorized">
        <div>
          <span (click)="openRecommendation()" class="underline">Submit Recommendation</span>
        </div>
        <div>
          <a href="https://www.morrisonhealthcare.com/privacy-policy/" target="_blank">Privacy
            Policy</a>
        </div>

        <div class="kt-margin-l-30 kt-margin-r-30">
          <a href="https://privacyportal-eu-cdn.onetrust.com/dsarwebform/8394ad8c-2b46-4837-8771-cbc69779a644/31bea1f4-92c3-440b-be0e-468af4f4b1f3.html?Source=MyMalnutrition"
            target="_blank">Data Requests</a>
        </div>
      </stg-ngx-footer>

    </div>

  </div>

</div>
